import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { CartEntryAdapter } from '@spartacus/cart/base/core'
import { CartModification, CART_MODIFICATION_NORMALIZER } from '@spartacus/cart/base/root'
import { ConverterService, OccEndpointsService } from '@spartacus/core'
import { Observable } from 'rxjs'

@Injectable()
export class CustomOccCartEntryAdapter implements CartEntryAdapter {
  constructor(
    protected http: HttpClient,
    protected occEndpointsService: OccEndpointsService,
    protected converterService: ConverterService
  ) {}

  public add(userId: string, cartId: string, productCode: string, quantity: number = 1): Observable<CartModification> {
    // const toAdd = JSON.stringify({});

    // const url = this.occEndpointsService.getUrl('addEntries', {
    //   userId,
    //   cartId,
    //   quantity,
    // });
    const url = this.occEndpointsService.buildUrl('addEntries', {
      // queryParams: { userId, cartId, quantity },
      urlParams: { userId, cartId, quantity }
    })

    // Handle b2b case where the x-www-form-urlencoded is still used
    if (url.includes(`quantity=${quantity}`)) {
      const headers = new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })

      return this.http
        .post<CartModification>(url, {}, { headers, params: { code: productCode } })
        .pipe(this.converterService.pipeable(CART_MODIFICATION_NORMALIZER))
    }

    const toAdd = {
      quantity,
      product: { code: productCode }
    }
    const headers = new HttpHeaders({
      // 'Content-Type': 'application/x-www-form-urlencoded',
      'Content-Type': 'application/json'
    })

    return this.http
      .post<CartModification>(url, toAdd, { headers })
      .pipe(this.converterService.pipeable(CART_MODIFICATION_NORMALIZER))
  }

  public update(
    userId: string,
    cartId: string,
    entryNumber: string,
    qty: number,
    pickupStore?: string
  ): Observable<CartModification> {
    let params = {}
    if (pickupStore) {
      params = {
        deliveryPointOfService: {
          name: pickupStore
        }
      }
    }

    const headers = new HttpHeaders({
      // 'Content-Type': 'application/x-www-form-urlencoded',
      'Content-Type': 'application/json'
    })

    // const url = this.occEndpointsService.getUrl('updateEntries', {
    //   userId,
    //   cartId,
    //   entryNumber,
    // });

    const url = this.occEndpointsService.buildUrl('updateEntries', {
      // queryParams: { userId, cartId, entryNumber },
      urlParams: { userId, cartId, entryNumber }
    })

    return (
      this.http
        // .patch<CartModification>(url, {}, { headers })
        .patch<CartModification>(url, { quantity: qty, ...params }, { headers })
        .pipe(this.converterService.pipeable(CART_MODIFICATION_NORMALIZER))
    )
  }

  public remove(userId: string, cartId: string, entryNumber: string): Observable<any> {
    const headers = new HttpHeaders({
      // 'Content-Type': 'application/x-www-form-urlencoded',
      'Content-Type': 'application/json'
    })

    // const url = this.occEndpointsService.getUrl('removeEntries', {
    //   userId,
    //   cartId,
    //   entryNumber,
    // });

    const url = this.occEndpointsService.buildUrl('removeEntries', {
      //queryParams: { userId, cartId, entryNumber },
      urlParams: { userId, cartId, entryNumber }
    })
    return this.http.delete(url, { headers })
  }
}
